module.exports = __webpack_public_path__ + "img/Weapon_152.42db1fdd.png";